/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const expandablePaperStyle = {
  paper: {
    padding: "1rem",
    height: "100%",
  },
  heading: {
    marginBottom: "1rem"
  },
};

export default expandablePaperStyle;
